//import Account from './../../Resources/script.js'
import commonfunctions from "../../Resources/commonfunctions";

export default {
    name: 'AccountProduct',
    mixins: [commonfunctions],
    data () {
        return {
           // products:{},
        }
    },

    components: {
        
    },
     
    methods: {

        setPage(){
            this.action_loading = true; //using *action_loading as *loading may be in use by loadCategories
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.products =  value.account.store_sellpoint.store_products;
                    if(self.products == undefined || (Object.keys(self.products).length == 0)){
                        self.getSellpointProducts();
                    }else{
                        self.action_loading = false;
                    }
                }else{}
            });
           // this.loadProducts();
            // this.products = this.$store.getters['account/getBusinessProducts'];
            // if(Object.keys(this.product).length > 0){
            //     //get product details
            // }
        },

        setProduct(data){
            this.$store.dispatch('account/setProduct',data);
            this.$router.push('/account/business/product');
        },
      
    },

    created: function(){
        this.setPage();
        this.loadCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Products/script.js